import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import {Deal, DealsService, UserLevels, UserService} from '../core';
import {catchError, map, tap} from 'rxjs/operators';

@Injectable()
export class EditableDealResolver implements Resolve<Deal> {
  constructor(
    private dealsService: DealsService,
    private router: Router,
    private userService: UserService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
      if (this.userService.isAuthenticated.valueOf()) {
          return this.dealsService.get(route.params['linkID'])
              .pipe(
                  map(
                      deal => {
                          if (this.userService.getCurrentUser().userID === deal.link_author ||
                              this.userService.getCurrentUser().level === UserLevels.Admin ||
                              this.userService.getCurrentUser().level === UserLevels.Moderator) {
                              return deal;
                          } else {
                              this.router.navigateByUrl('/');
                          }
                      }
                  ),
                  catchError((err) => this.router.navigateByUrl('/home'))
              );
      } else {
          this.router.navigateByUrl('/');
      }
  }
}
